// app/not-found.tsx
'use client'
import { Button, Typography } from '@mui/material'
import { useRouter } from 'next/navigation'
import { FlexCol } from '../components/layout'

const NotFoundPage = () => {
  const router = useRouter()

  return (
    <FlexCol
      gap="md"
      align="center"
      justify="center"
      // biome-ignore lint/plugin: full-viewport centred error page
      sx={{ height: '100vh', textAlign: 'center' }}
    >
      <Typography variant="h5">
        Oops! The page you’re looking for doesn’t exist
      </Typography>
      <Typography variant="h6">
        Please let us know if you clicked a link to get here.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={() => router.push('/')}
      >
        Go Back Home
      </Button>
    </FlexCol>
  )
}

export default NotFoundPage
